import React from 'react';
import { TrendingUp, ShieldX, FileText } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <TrendingUp className="w-8 h-8 text-gold-500" data-id="element-11" />,
    title: 'Aumenta tu Puntaje',
    description: 'Aprende las estrategias exactas para sumar puntos a tu perfil de crédito mes a mes, de forma legal y segura.'
  }, {
    icon: <ShieldX className="w-8 h-8 text-gold-500" data-id="element-12" />,
    title: 'Elimina Deudas Negativas',
    description: 'Descubre cómo disputar y remover colecciones, pagos tarde y bancarrotas que están hundiendo tu puntaje.'
  }, {
    icon: <FileText className="w-8 h-8 text-gold-500" data-id="element-13" />,
    title: 'Construye Historial',
    description: 'Incluso si empiezas desde cero o tienes ITIN, te mostramos cómo crear un historial sólido que los bancos amen.'
  }];
  return <section className="py-24 bg-white" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-17">
            CRÉDITO EN USA: <span className="text-gold-500" data-id="element-18">SIN SECRETOS</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-19">
            Aprende cómo funciona el sistema y cómo usarlo a tu favor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-20">
          {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:shadow-lg transition-shadow h-full" data-id="element-21">
              <div className="w-16 h-16 bg-navy-900 rounded-2xl flex items-center justify-center mb-6 shadow-md" data-id="element-22">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-23">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-24">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}